class WLSCollectiblesGrid extends HTMLElement {
    constructor() {
        super();

        this.classes = {
            slider: 'carousel',
            item: 'carousel-cell',
            navigation: {
                prev: 'js-collectibles-prev',
                next: 'js-collectibles-next',
                pagination: 'js-collectibles-dots'
            }
        };

        this.elements = {
            slider: this.querySelector(`.${this.classes.slider}`),
            items: this.querySelectorAll(`.${this.classes.item}`),
            navigation: {
                prev: this.querySelector(`.${this.classes.navigation.prev}`),
                next: this.querySelector(`.${this.classes.navigation.next}`),
                pagination: this.querySelector(`.${this.classes.navigation.pagination}`)
            }
        };

        this.resizeHandler = this.handleResize.bind(this);
    }

    connectedCallback() {
        if (this.checkIfEmpty()) return;
        this.init();
        window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
        if (this.flickity) {
            this.flickity.destroy();
        }
        window.removeEventListener('resize', this.resizeHandler);
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
    }

    checkIfEmpty() {
        const sliderInner = this.elements.slider;
        if (!sliderInner || !sliderInner.children.length) {
            this.style.display = 'none';
            return true;
        }
        return false;
    }

    init() {
        if (!this.shouldInitialize()) return;
        this.initializeFlickity();
    }

    shouldInitialize() {
        if (!this.elements.slider || !this.elements.items.length) return false;

        const width = window.innerWidth;
        const slidesCount = this.elements.items.length;

        if (width < 768 && slidesCount <= 1) return false;
        if (width >= 768) return false;

        return true;
    }

    handleResize() {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = setTimeout(() => {
            const shouldInit = this.shouldInitialize();

            if (shouldInit && !this.flickity) {
                this.initializeFlickity();
            } else if (!shouldInit && this.flickity) {
                this.flickity.destroy();
                this.flickity = null;
            }
        }, 300);
    }

    initializeFlickity() {
        this.flickity = new Flickity(this.elements.slider, {
            cellAlign: 'left',
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            groupCells: true
        });

        // Navigation
        if (this.elements.navigation.prev) {
            this.elements.navigation.prev.addEventListener('click', () => {
                this.flickity.previous();
            });
        }

        if (this.elements.navigation.next) {
            this.elements.navigation.next.addEventListener('click', () => {
                this.flickity.next();
            });
        }

        // Pagination
        if (this.elements.navigation.pagination) {
            this.flickity.cells.forEach((cell, index) => {
                const button = document.createElement('button');
                button.classList.add('dot');
                button.addEventListener('click', () => {
                    this.flickity.select(index);
                });
                this.elements.navigation.pagination.appendChild(button);
            });

            // Update dots on slide change
            this.flickity.on('select', () => {
                const dots = this.elements.navigation.pagination.querySelectorAll('.dot');
                dots.forEach((dot, i) => {
                    dot.classList.toggle('is-selected', i === this.flickity.selectedIndex);
                });
            });

            this.flickity.emitEvent('select');
        }
    }
}

if (!customElements.get('wls-collectibles-grid')) {
    customElements.define('wls-collectibles-grid', WLSCollectiblesGrid);
}
